// extracted by mini-css-extract-plugin
module.exports = {"firstHalfInput":"DebtForm_firstHalfInput__3BeW6","secondHalfInput":"DebtForm_secondHalfInput__uan53"};